import { useEffect } from 'react';

export const useMountEffect = (effect: VoidFunction) => {
	useEffect(() => {
		effect();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
};
